import React, { Component } from "react";
import LoginImage from "./../asset/images/sepandlogo.png";
import Background from "./../asset/images/background.jpg";
import { AsyncTypeahead } from "react-bootstrap-typeahead";

export default class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      restaurants: [],
      isLoading: false,
    };

    this.acResturant = React.createRef();
  }

  componentDidMount() {
    this.acResturant.current.focus();
  }

  searchResturant(query) {
    let data = {
      businessName: query,
      token: "c305bf74-4cd9-41e9-b304-a5b94wsaq331c",
    };
    this.setState({ isLoading: true });

    fetch("https://api.sepandplus.ontco.com/publicapi/searchBusinessName", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          this.setState({ restaurants: result.result, isLoading: false });
        } else {
          this.setState({ restaurants: [], isLoading: false });
        }
      })
      .catch((err) => {
        this.setState({ restaurants: [], isLoading: false });
      });
  }

  acResturantChange(item) {
    try {
      if (item.length < 1) {
        return;
      }
      this.props.history.push(`${item[0].code}/`);
    } catch (error) {}
  }

  onRegister() {
    window.open("https://cp.sepandplus.ontco.com/");
  }

  render() {
    return (
      <div className="Login">
        <img
          src={Background}
          alt=""
          style={{
            position: "absolute",
            left: "0",
            top: "0",
            width: "100vw",
            height: "100vh",
            objectFit: "cover",
            zIndex: "0",
          }}
        />
        <div className="header"></div>
        <div className="LoginContent">
          <img src={LoginImage} alt="" className="LoginPicture" />
          <div className="MobilePage">
            <AsyncTypeahead
              id="resturantAutoCompelete"
              useCache={true}
              ref={this.acResturant}
              isLoading={this.state.isLoading}
              labelKey="name"
              minLength={2}
              onSearch={this.searchResturant.bind(this)}
              options={this.state.restaurants}
              placeholder=" نام رستوران "
              delay={100}
              emptyLabel="هیچ رستورانی پیدا نشد"
              flip={true}
              clearButton={true}
              searchText="در حال جستجو..."
              onChange={this.acResturantChange.bind(this)}
            />
            <div
              onClick={
                this.state.buttonDisabled
                  ? (event) => event.preventDefault()
                  : this.onRegister.bind(this)
              }
              className="linkStyle"
              style={{ marginTop: "40px" }}
            >
              ایجاد رستوران در سپند پلاس
            </div>
          </div>
        </div>
      </div>
    );
  }
}
